import {Flex,  SVGButton, ToogleSwitch} from '/app/src/component';
import React from 'react';

const HeaderStyle = {
    dataName: 'MainPanelExchangeHeader',
    width: '100%',
    vAlignContent: 'center',
    hAlignContent: 'left',
    padding: '10px 30px',
    color: 'black',
    fontSize: '18px',
    shrink: 0,
    fontWeight: 500,

}
const SaveButtonStyle = {
    dataName: 'ExchangeLiveButton',
    color: 'black',
    hover: 'blue',
    height: '49px',
    manual: true,
    src: '/images/Save.svg',
}
export default ({onSave , live, onLiveChange, changed,
    liveDisable, liveReason, ...rest
}) => {
    return (
        <Flex {...HeaderStyle}>
            <ToogleSwitch {...SaveButtonStyle} on={live} onChange={onLiveChange}
                disable={liveDisable} disableReason={liveReason}
            />
            <Flex ml='10px'>
            Aktivera Växelsystem (Live)
            </Flex>
            <SVGButton {...SaveButtonStyle} text='Spara' ml='auto' disabled={!changed} onClick={onSave} border/>
        </Flex>
    )
}



// WEBPACK FOOTER //
// ./src/layout/Dashboard/MainPanel/ClientChatSettings/Exchange/_Header.js